import { Color } from "config/colors";
import styled from "styled-components";

export const ModalBody = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background-color: ${Color.White};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  outline: none;
  border-radius: 8px;
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
  p {
    margin: 0 0 30px 0;
  }
`;

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  div {
    margin: 0 0 10px 0;
  }
`;